/**
 * ユーザー
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/vote_staffs`

 const search_vote_staff = {
   namespaced: true,
   state: {},
   getters: {},
   actions: {
     index (context, params) {
       return new Promise((resolve) => {
         Vue.$http.get(API_PATH, { params }).then(data => {
           resolve(data.content)
         })
       })
     },
   },
   mutations: {},
 }
 export default search_vote_staff
